import { ErrorFeedback } from 'components/common-form/sidePanel/priceEnhancer/priceImprovement/actions/errorFeedback';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import type { AcknowledgePanelProps } from './AcknowledgePanel.connect';
import { connectAcknowledgePanel } from './AcknowledgePanel.connect';

const Container = styled.div`
  height: 3.5rem;
`;
export const AcknowledgePanelRaw: FC<AcknowledgePanelProps> = ({
  selectionSize,
  error,
  onAcknowledge,
  onErrorDismissed,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Container className="alert alert-info m-0 py-2 d-flex flex-row align-items-center">
      <span className="badge rounded-pill bg-white text-black me-3">{selectionSize}</span>
      <span className="flex-grow-1 text-white">
        {formatMessage({ id: 'priceImprovementBlotter.acknowledgeableItems.message' })}
      </span>
      {error ? (
        <ErrorFeedback
          errorType="acknowledgement"
          error={error}
          className="btn btn-lg btn-outline-white"
          onDimiss={onErrorDismissed}
          position="bottom"
        />
      ) : (
        <button type="button" className="btn btn-lg btn-outline-white" onClick={onAcknowledge}>
          {formatMessage({ id: 'acknowledge' })}
        </button>
      )}
    </Container>
  );
};

export const AcknowledgePanel = connectAcknowledgePanel(AcknowledgePanelRaw);
